import {
    IDatiqInput,
    IDatiqOption,
    generateInput,
    generateOption,
} from '@dat/datiq-components-pkg/utils';
import {
    Arbitrary,
    array,
    boolean,
    constantFrom,
    record,
    string,
} from 'fast-check';
import {
    DatiqSelectEnumAppearance,
    DatiqSelectEnumStyle,
    IDatiqSelect,
} from './datiq-select.interface';

interface IDatiqSelectParts {
    options: IDatiqOption[];
    multiple: boolean;
    style: DatiqSelectEnumStyle;
    appearance?: DatiqSelectEnumAppearance;
    tooltipClass?: string;
}

const generateSelectParts: () => Arbitrary<IDatiqSelectParts> = () => {
    return record(
        {
            options: array(generateOption()),
            multiple: boolean(),
            style: constantFrom(
                DatiqSelectEnumStyle.Standard,
                DatiqSelectEnumStyle.Thin
            ),
            appearance: constantFrom(
                DatiqSelectEnumAppearance.Standard,
                DatiqSelectEnumAppearance.Outline
            ),
            tooltipClass: string(),
        },
        { requiredKeys: ['options', 'multiple', 'style'] }
    );
};

export const generateSelect: () => Arbitrary<IDatiqSelect> = () => {
    return generateInput().chain((input: IDatiqInput) =>
        generateSelectParts().map((parts: IDatiqSelectParts) => ({
            ...input,
            ...parts,
        }))
    );
};
